import axios from "axios";

const axiosCustom = (_config, _data) => {
  const {} = JSON.parse(sessionStorage.getItem("login"))
    ? JSON.parse(sessionStorage.getItem("login"))
    : {
        token: "3cf61fab-b50a-410f-9d59-3357ee4706fe",
        member_id: "_0zehXYBdxxYGfkX5_wd",
      };

  let config = {
    baseURL: getUrl(),
    method: "get",
    headers: {
      "access-token": "5780C1CA-AD9C-4AE1-954E-2E6F528275A1",
      Authorization: "5780C1CA-AD9C-4AE1-954E-2E6F528275A1",
    },
    ..._config,
    data: {
      // api_key: "d025488f-8ec6-4434-afbe-b6a5343815a7",
      // token,
      // member_id,
      // ..._data
    },
  };

  return axios(config);
};

function getUrl() {
  return "/Home/";
  // let protocol = window.location.protocol;
  // let hostName = window.location.hostname;

  // if (!protocol || !hostName || hostName === "localhost") {
  //   return "http://automationapi.mobinsb.com/api/External/Web/";
  // }

  // return `${protocol}//${hostName}/api/External/Web/`;
}

export default axiosCustom;
